import { Link } from "react-router-dom";
import useStoreGridCollaborator from "../store/useStore";
//@ts-ignore
import { CSVLink } from "react-csv";

export default function TitleGridCollaborator() {
  const { inactiveOrActive, csvDataInactived, csvDataActived, collaboratorActivated, collaboratorsDeleted } = useStoreGridCollaborator();
  return (
    <div className="collaboratorTitleContainer box-title">
      <h1>
        {inactiveOrActive ? `${collaboratorsDeleted?.length} - Profissionais inativos` : `${collaboratorActivated?.length} - Profissionais ativos`}
      </h1>
      <div className="flex btnContainer">
        <Link className="Link btn px-2" to={"/collaborator/form"}>
          Novo profissional
        </Link>
        {csvDataActived?.length || csvDataInactived?.length ? (
          <CSVLink
            data={inactiveOrActive ? csvDataInactived : csvDataActived}
            filename={`${"profissionais"}.csv`}
            target="_blank"
            className="Link email btn bg-secondary m-top10 px-2"
          >
            {/* <button className="Link email btn bg-secondary m-top10"> */}
            Download CSV
            {/* </button> */}
          </CSVLink>
        ) : (
          <button className="Link email btn bg-secondary m-top10 px-2" disabled>
            Download CSV
          </button>
        )}
      </div>
    </div>
  );
}
